import createHttp from './httpFactory';
import errorHandler from './httpErrorHandler';

export default createHttp({
  errorHandler,
});
